import { Component, Input, OnInit } from '@angular/core';
import { A48ReportTypes } from 'src/app/enums/reports/reports.enum';
import { Act48ParaReportEntry } from 'src/app/model/a48/act48-para-report-entry.model';
import { CplA48ParaReportRequest } from 'src/app/model/cpl-a48-para-report-reqest.model';
import { A48UserStatus } from 'src/app/model/enum/a48-user-status.enum';
import { Act48ReportHelpersService } from 'src/app/services/a48-report-helpers/a48-report-helpers.service';
import { DateHelpers, PagedResponse } from '@edl-development/edl-common';
import { A48ReportPerms } from 'src/app/enums/reports/a48-report-perms.enum';
import { A48SubmissionContextCode } from 'src/app/model/enum/a48-submission-context-code.enum';

@Component({
    templateUrl: './a48-para-print-report.component.html',
    styleUrls: ['./a48-para-print-report.component.scss']
})
export class A48PrintParaReportComponent implements OnInit {
    @Input() pagedResponse: PagedResponse;
    @Input() request: CplA48ParaReportRequest;

    reportContent: Act48ParaReportEntry[];

    DateHelpers = DateHelpers;
    A48ReportTypes = A48ReportTypes;
    A48UserStatus = A48UserStatus;
    A48SubmissionContextCode = A48SubmissionContextCode;

    constructor(
        public act48ReportHelpersService: Act48ReportHelpersService
    ) {}

    ngOnInit() {
        this.reportContent = this.pagedResponse.Results;
    }

    getPermsLabel() {
        switch (this.request.Perms) {
            case A48ReportPerms.NO_PERMS:
                return 'Not Submitted';
            case A48ReportPerms.PERMS:
                return 'Submitted';
            default:
                return 'All Completed Submissions';
        }
    }

    getTitle = () => {
        return this.act48ReportHelpersService.getTitle(this.request.Type, this.request.ItemSubType);
    }
}